import {
  lazyAMapApiLoaderInstance
} from 'vue-amap';
import { orderSource } from "@/utils/env"

const Geo = {
  data() {
    return {
      defaultCity: {
        city: '定位中...',
        adCode: '0',
      },
    }
  },
  methods: {
    initGeo(callback = function () {}) {
      let self = this;
      lazyAMapApiLoaderInstance.load().then(() => {
        this.map = new AMap.Map('amapContainer', {
          center: [114.34387, 30.54279],
          zoom: 18,
          resizeEnable: true
        });
        this.map.plugin('AMap.Geolocation', () => {
          let geolocation = new AMap.Geolocation({
            GeoLocationFirst:true
          });
          geolocation.getCityInfo(function (status,result) {
            // console.log(status,result);
            switch (status){
              case "complete":
                self.defaultCity = {
                  city: result.city ? result.city : "请选择城市",
                  adCode: result.city ? result.adcode : 0
                };
                callback();
                break;
              case "error":
                self.defaultCity = {
                  city: "请选择城市",
                  adCode: "0"
                };
                callback();
                break;
            }
          });
        });
      });
    }
  }
};

const Nav = {
  data() {
    return {
      amapUrl: "",
      isAmapShow: false
    }
  },
  methods: {
    goNavigation(lng, lat) {
      this.flexible.showLoading({
        content: "路径规划中..."
      });
      let self = this;

      lazyAMapApiLoaderInstance.load().then(() => {
        this.map = new AMap.Map("iCenter", {
          center: [114.34387, 30.54279],
          zoom: 18,
          resizeEnable: true
        });
        this.map.plugin("AMap.Geolocation", () => {
          let geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,
            timeout: 10e3,
            buttonOffset: new AMap.Pixel(10, 20),
            zoomToAccuracy: true,
            buttonPosition: 'RB',
            GeoLocationFirst: true
          });
          this.map.addControl(geolocation);
          geolocation.getCurrentPosition();
          AMap.event.addListener(geolocation, 'complete', function (obj) {
            self.flexible.hideLoading();
            self.isAmapShow = !self.isAmapShow;
            self.amapUrl = `https://m.amap.com/navi/?start=${obj.position.lng},${obj.position.lat}&dest=${lng},${lat}&destName=&key=ab5f10a7dea8cdc8bd2db88fdc29070c`;
          });
          AMap.event.addListener(geolocation, 'error', function (val) {
            self.flexible.hideLoading();
            self.flexible.showToast({
              content: '请打开GPS定位服务',
              duration: 2000
            });
          });
        });
      });

    },
  }
};



export {
  Geo,
  Nav
}
